import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-confirm-window',
  templateUrl: './confirm-window.component.html',
  styleUrls: ['./confirm-window.component.css']
})
export class ConfirmWindowComponent implements OnInit {
  public confirmForm: FormGroup;
  public isOpenConfirmCorrectPopup = false;
  public alphaNumericPattern: RegExp;
  public warningMessage: string;
  public validationMessages = {};
  public Title: string;
  public SubTitle: string;

  constructor(private fb: FormBuilder) {
    this.Title = 'Change Fee Plan';
    this.SubTitle = 'You will be removing all data and payments from the existing fee plan and\
    adding the payments to the new fee plan.The admin must type "APPROVE" in all caps and then hit save.';
    this.alphaNumericPattern = /^[a-zA-Z ]+$/;
    this.warningMessage = 'Please type "APPROVE" in all caps.';
    this.validationMessages = {
      'Required': 'This field is required.',
      'Pattern': 'Only characters valid in this field.',
    };
  }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.confirmForm = this.fb.group({
      txtConfirmText: [null, [Validators.required, Validators.pattern(this.alphaNumericPattern)]]
    });
  }

  isConfirmTextMatched(confirmWithText) {
    const val = this.confirmForm.get('txtConfirmText').value;
    if (val) {
      return (val.trim() === confirmWithText) ? true : false;
    }
  }

  isConfirmTextValid() {
    return this.confirmForm.get('txtConfirmText').errors
      && (this.confirmForm.get('txtConfirmText').touched
      || this.confirmForm.get('txtConfirmText').dirty);
  }

  validateUi() {
    Object.keys(this.confirmForm.controls).forEach(field => {
      const control = this.confirmForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  openPopup() {
    this.isOpenConfirmCorrectPopup = true;
    console.log('openPopup() called in confirm-window component.');
  }

  closePopup() {
    const control = this.confirmForm.get('txtConfirmText');
    control.reset();
    control.clearValidators();
    control.updateValueAndValidity();
    this.isOpenConfirmCorrectPopup = false;
  }

  onPopUpConfirm(event, formValue, confirmWithText) {
    event.stopPropagation();
    const flag = this.isConfirmTextMatched(confirmWithText);
    if (flag) {
      this.closePopup();
      // emit required function
      // this.saveFeePlan();
      alert('ok');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/confirm-window/confirm-window.component.ts